import React from 'react'
import { Helmet } from 'react-helmet-async'
import styles from './styles.module.css'

// component function
export default function NotFound() {
	return (
		<>
			<Helmet>
				<title>Not found | Flowsam</title>
			</Helmet>
			<div className={styles.container}>
				<h2>404 - Not found</h2>
			</div>
		</>
	)
}
